export const BUSSINESS_NAME = process.env.REACT_APP_BUSSINESS_NAME
export const APP_PUBLIC_URL = '/'

export const BASE_URL = process.env.REACT_APP_BASE_URL
const Version = "v1";

export const API_URL_ENDPOINT = {
    //auth
    Login: `${BASE_URL}/api/${Version}/Auth/signin`,
    ForgotPassword: `${BASE_URL}/api/${Version}/Auth/forgot`,
    ValidateToken: `${BASE_URL}/api/${Version}/Auth/validate-reset-token`,
    ResetPassword: `${BASE_URL}/api/${Version}/Auth/reset-password`,


    Pincodes: `${BASE_URL}/api/${Version}/Other/pincodes`,
    Load: `${BASE_URL}/api/${Version}/Load`,
    Bilty: `${BASE_URL}/api/${Version}/Bilty`,
    TransporterLoadRequest: `${BASE_URL}/api/${Version}/Load/trasnporter-request`,
    Shipper: `${BASE_URL}/api/${Version}/Shipper`,
    Transporter: `${BASE_URL}/api/${Version}/Transporter`,
    Truck: `${BASE_URL}/api/${Version}/Truck`,
    Document: `${BASE_URL}/api/${Version}/Document`,
    States: `${BASE_URL}/api/${Version}/Other/states`,
    Cities: `${BASE_URL}/api/${Version}/Other/cities`,
    KYC: `${BASE_URL}/api/${Version}/KYC`,
    Company: `${BASE_URL}/api/${Version}/Company`,
    Users: `${BASE_URL}/api/${Version}/User`,
    UserGroup: `${BASE_URL}/api/${Version}/Other/user-groups`,
    UserGroupPermission: `${BASE_URL}/api/${Version}/Other/usergroup-permission`,
    Files: `${BASE_URL}/api/${Version}/Other/folderdata`,
        

}
